import { maxLength } from '@seek/validators-js';
import { TextField } from 'braid-design-system';
import React from 'react';

import { mapBraidFieldProps } from 'src/utils/mapBraidFieldProps';
import { numerical } from 'src/utils/validators';

import { useField } from '../formState';

const PhoneNumberField = () => {
  const phonePrefix = useField({
    id: 'phoneCountryCode',
  });

  const phoneNumber = useField({
    id: 'phoneNumber',
    validators: [numerical, maxLength],
    validatorProps: { max: 10 },
  });

  return (
    <TextField
      id="phone-number-field"
      type="tel"
      prefix={`+${phonePrefix.value ?? '61'}`}
      label="Phone number"
      {...mapBraidFieldProps(phoneNumber)}
    />
  );
};

export default PhoneNumberField;
